export const MILEAGE_CORRECTION_CONFIG = {
  ALLOWED_ROLES: ["Super Admin", "Admin", "Manager"],
  MAX_REASON_LENGTH: 50,
  MODAL_WIDTH: "460px",
  ICON_SIZE: {
    small: 14,
    medium: 16,
    large: 20
  }
} as const;
